import { updateFeed } from "@/mocks/home";
import SectionHeading from "@/pages/home/components/SectionHeading";

export default function UpdateFeed() {
  return (
    <section id="updates" className="border-y border-background-200 bg-background-100">
      <div className="px-4 py-12 md:px-6 md:py-16">
        <div className="mx-auto max-w-page">
          <SectionHeading
            index="04 / 更新快讯"
            title="短讯并行，地址与版本的变化都记在这儿"
            desc="版本发布、线路校验与临时提醒按时间排列，看两行就知道今天有没有需要重新找入口。"
          />

          <div className="mt-9 grid grid-cols-1 gap-x-10 gap-y-0 lg:grid-cols-2">
            {updateFeed.map((item) => (
              <article
                key={item.id}
                className="flex gap-4 border-b border-background-200 py-5 last:border-0"
              >
                <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-accent-100 text-accent-700">
                  <i className="ri-flashlight-line" />
                </div>
                <div className="min-w-0 flex-1">
                  <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
                    <span className="font-mono text-xs text-foreground-500">{item.time}</span>
                    <span className="rounded-full bg-secondary-100 px-2 py-0.5 text-[11px] text-secondary-800">
                      {item.tag}
                    </span>
                  </div>
                  <h3 className="mt-1.5 text-sm font-medium text-foreground-950 md:text-base">
                    {item.title}
                  </h3>
                  <p className="mt-1 text-sm leading-relaxed text-foreground-600">{item.summary}</p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}